import { set } from "@ember/object"
import type { CardStack } from "@shared/models/card-stack"
import type { PatchModel } from "@shared/models/patch"
import type EmberStore from "../../ember-store"
import type InternalSupergrainStore from "../../internal-supergrain-store"

export function clearCardsUpdatingFromTemplate(
  patch: PatchModel,
  store: EmberStore,
  internalSupergrainStore: InternalSupergrainStore,
) {
  if (patch.document.modelType !== "card-stack") return
  const setsCards =
    patch.embeddedDocument?.path === "attributes.cards" ||
    patch.document.ops.set?.some(([path]) => path === "attributes.cards")
  if (!setsCards) return

  const emberCardStack = store.findInMemory("card-stack", patch.document.id)
  if (emberCardStack) set(emberCardStack.meta, "cardsUpdatingFromTemplate", false)

  const reactCardStack = internalSupergrainStore.findInMemory("card-stack", patch.document.id) as
    | CardStack
    | undefined
  if (reactCardStack) reactCardStack.meta.cardsUpdatingFromTemplate = false
}

export default function (
  this: { store: EmberStore; internalSupergrainStore: InternalSupergrainStore },
  foreignPatchStream,
) {
  foreignPatchStream.onValue(([patch]) =>
    clearCardsUpdatingFromTemplate(patch, this.store, this.internalSupergrainStore),
  )
}
